import * as Yup from 'yup';

export const passwordResetValidation = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),

})



export const confirmPasswordResetValidation = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    code: Yup.string().min(3, 'code length too short').required('Verification Code is required'),
    newPassword: Yup.string().min(6, 'Password too short').matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).*$/, 'Password must have lowercase, uppercase characters, a number, and a special character')
    .required('Password is required'),


})